<script>
import axios from "axios";

export default {
  name: "whatsapp-link",
  data() {
    return {
      user: JSON.parse(localStorage.getItem("user")),
      whatsapp_link: "",
      loading: true,
    };
  },
  methods: {
    getData() {
      const formData = new FormData();
      if (this.user.academic_year_id) formData.append('academic_year_id', this.user.academic_year_id);
      formData.append('gender', this.user.gender === 2 ? "female" : "male");
      axios
        .post('/get_whatsapp_link', formData)
        .then((response) => {
          this.whatsapp_link = response.data.whatsapp_link;
        })
        .catch((error) => {
          console.log("error", error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  mounted() {
    this.getData();
  },
};
</script>

<template>
  <div class="wa-page">
    <!-- Animated blobs -->
    <div class="wa-blob wa-blob-1"></div>
    <div class="wa-blob wa-blob-2"></div>
    <div class="wa-blob wa-blob-3"></div>

    <!-- Card -->
    <div class="wa-card">

      <!-- Animated icon -->
      <div class="wa-icon-wrap">
        <div class="wa-pulse wa-pulse-1"></div>
        <div class="wa-pulse wa-pulse-2"></div>
        <div class="wa-icon-circle">
          <svg viewBox="0 0 24 24" fill="currentColor">
            <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
          </svg>
        </div>
      </div>

      <h1 class="wa-title">مجموعة الواتساب</h1>
      <p class="wa-subtitle">انضم لمجموعة واتساب صفّك لمتابعة أحدث الشروحات والإعلانات</p>

      <!-- Features row -->
      <div class="wa-features">
        <div class="wa-feature">
          <span class="wa-feat-icon">📢</span>
          <span>إعلانات فورية</span>
        </div>
        <div class="wa-feature">
          <span class="wa-feat-icon">📖</span>
          <span>مراجعات يومية</span>
        </div>
        <div class="wa-feature">
          <span class="wa-feat-icon">🎯</span>
          <span>نصائح المذاكرة</span>
        </div>
      </div>

      <!-- Loading skeleton -->
      <div v-if="loading" class="wa-btn-skeleton"></div>

      <!-- Join button -->
      <a v-else-if="whatsapp_link" :href="whatsapp_link" target="_blank" class="wa-btn">
        <svg viewBox="0 0 24 24" fill="currentColor" class="wa-btn-icon">
          <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
        </svg>
        اضغط للانضمام للمجموعة
      </a>

      <!-- No link state -->
      <div v-else class="wa-no-link">
        <span>⏳</span>
        <p>الرابط غير متاح حالياً، سيتم إضافته قريباً</p>
      </div>

    </div>
  </div>
</template>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Cairo:wght@400;600;700;800;900&display=swap');
*, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }

.wa-page {
  min-height: calc(100vh - 70px);
  background: linear-gradient(135deg, #064e3b 0%, #065f46 40%, #047857 100%);
  display: flex; align-items: center; justify-content: center;
  font-family: 'Cairo', sans-serif;
  direction: rtl;
  padding: 2rem 1.25rem;
  position: relative; overflow: hidden;
}

/* Blobs */
.wa-blob {
  position: absolute; border-radius: 50%;
  filter: blur(70px); opacity: 0.25; pointer-events: none;
  animation: waBlobFloat 10s ease-in-out infinite;
}
.wa-blob-1 { width: 500px; height: 500px; background: #25D366; top: -150px; right: -100px; animation-duration: 12s; }
.wa-blob-2 { width: 350px; height: 350px; background: #128C7E; bottom: -80px; left: -80px; animation-duration: 9s; animation-delay: -3s; }
.wa-blob-3 { width: 250px; height: 250px; background: #075E54; top: 50%; left: 50%; transform: translate(-50%,-50%); animation-duration: 7s; animation-delay: -5s; }
@keyframes waBlobFloat {
  0%,100% { transform: scale(1) translate(0,0); }
  33% { transform: scale(1.1) translate(20px,-15px); }
  66% { transform: scale(0.92) translate(-15px,20px); }
}

/* Card */
.wa-card {
  position: relative; z-index: 1;
  background: rgba(255,255,255,0.1);
  backdrop-filter: blur(24px);
  border: 1px solid rgba(255,255,255,0.2);
  border-radius: 32px;
  padding: 3rem 2.5rem;
  max-width: 480px; width: 100%;
  text-align: center;
  box-shadow: 0 32px 80px rgba(0,0,0,0.3);
}

/* Animated icon */
.wa-icon-wrap {
  position: relative;
  width: 100px; height: 100px;
  margin: 0 auto 1.75rem;
  display: flex; align-items: center; justify-content: center;
}
.wa-pulse {
  position: absolute; inset: 0; border-radius: 50%;
  border: 2px solid rgba(37,211,102,0.6);
  animation: waPulse 2.5s ease-out infinite;
}
.wa-pulse-2 { animation-delay: 1.25s; }
@keyframes waPulse {
  0% { transform: scale(1); opacity: 0.8; }
  100% { transform: scale(1.8); opacity: 0; }
}
.wa-icon-circle {
  width: 80px; height: 80px; border-radius: 50%;
  background: linear-gradient(135deg, #25D366, #128C7E);
  display: flex; align-items: center; justify-content: center;
  box-shadow: 0 16px 40px rgba(37,211,102,0.45);
  position: relative; z-index: 1;
}
.wa-icon-circle svg { width: 42px; height: 42px; fill: #fff; }

.wa-title {
  font-size: 1.9rem; font-weight: 900; color: #fff;
  margin-bottom: 0.5rem; text-shadow: 0 2px 12px rgba(0,0,0,0.2);
}
.wa-subtitle {
  font-size: 0.95rem; color: rgba(255,255,255,0.8);
  line-height: 1.6; margin-bottom: 1.75rem;
}

/* Features */
.wa-features {
  display: flex; justify-content: center; gap: 0.75rem;
  flex-wrap: wrap; margin-bottom: 2rem;
}
.wa-feature {
  display: flex; align-items: center; gap: 0.4rem;
  background: rgba(255,255,255,0.12);
  border: 1px solid rgba(255,255,255,0.2);
  color: #fff; font-size: 0.82rem; font-weight: 700;
  padding: 0.4rem 0.9rem; border-radius: 99px;
}
.wa-feat-icon { font-size: 1rem; }

/* Skeleton */
.wa-btn-skeleton {
  height: 60px; border-radius: 18px;
  background: linear-gradient(90deg, rgba(255,255,255,.1) 25%, rgba(255,255,255,.2) 50%, rgba(255,255,255,.1) 75%);
  background-size: 200% 100%;
  animation: waSkel 1.4s infinite;
}
@keyframes waSkel { 0%{background-position:200% 0} 100%{background-position:-200% 0} }

/* Button */
.wa-btn {
  display: flex; align-items: center; justify-content: center; gap: 0.75rem;
  width: 100%; padding: 1rem 2rem;
  background: linear-gradient(135deg, #25D366, #128C7E);
  color: #fff; text-decoration: none;
  border-radius: 18px; font-size: 1.1rem; font-weight: 800;
  box-shadow: 0 16px 40px rgba(37,211,102,0.4);
  transition: all 0.3s;
  border: 1px solid rgba(255,255,255,0.2);
}
.wa-btn:hover {
  transform: translateY(-4px);
  box-shadow: 0 24px 60px rgba(37,211,102,0.55);
  color: #fff;
}
.wa-btn-icon { width: 26px; height: 26px; flex-shrink: 0; }

/* No link */
.wa-no-link {
  background: rgba(255,255,255,0.08);
  border: 1px solid rgba(255,255,255,0.15);
  border-radius: 16px;
  padding: 1.5rem;
  color: rgba(255,255,255,0.75);
}
.wa-no-link span { font-size: 2rem; display: block; margin-bottom: 0.5rem; }
.wa-no-link p { font-size: 0.9rem; }

@media (max-width: 480px) {
  .wa-card { padding: 2.25rem 1.5rem; border-radius: 24px; }
  .wa-title { font-size: 1.5rem; }
  .wa-features { gap: 0.5rem; }
}
</style>
